
import * as go from "gojs";
import { checkEmpty } from "src/service/util.service";


let defualtProfileUrl = window.location.origin + "/center-web/images/user.png";
const $$ = go.GraphObject.make;

// this is used to determine feedback during drags
function mayWorkFor(node1: any, node2: any) {
  if (!(node1 instanceof go.Node)) return false;  // must be a Node
  if (node1 === node2) return false;  // cannot work for yourself
  if (node2.isInTreeOf(node1)) return false;  // cannot work for someone who works for you
  return true;
}

// This function provides a common style for most of the TextBlocks.
// Some of these values may be overridden in a particular TextBlock.
function textStyle() {
  return { font: "10pt  Segoe UI,sans-serif" };
}
function textStyleName() {
  return { font: "10pt  Segoe UI,sans-serif", stroke: "black" };
}
function textStylePosition() {
  return { font: "10pt  Segoe UI,sans-serif", stroke: "#767676" };
}

// This converter is used by the Picture.
function findHeadShot(profileUrl: any) {
  console.log("profileUrl", profileUrl)
  if (checkEmpty(profileUrl)) {

    return defualtProfileUrl;
  }
  return profileUrl;

}



/*
 * "BoTreeExpanderButton" is only used in Business object Diagram
 * */

go.GraphObject.defineBuilder("BoTreeExpanderButtonChart", function (args: any) {
  var button =
    go.GraphObject.make("Button",
      { // set these values for the isTreeExpanded binding conversion
        "_treeExpandedFigure": window.location.origin + "/center-web/images/collapsed-arrow.png",
        "_treeCollapsedFigure": window.location.origin + "/center-web/images/expand-arrow.png"
      },
      go.GraphObject.make(go.Picture,  // the icon
        {
          name: "ButtonIcon",
          source: window.location.origin + "/center-web/images/expand-arrow.png",  // default value for isTreeExpanded is true
          desiredSize: new go.Size(16, 16)
        },
        // bind the Shape.figure to the Node.isTreeExpanded value using this converter:
        new go.Binding("source", "isTreeExpanded",
          function (exp: any, shape: any) {
            var button = shape.panel;
            return exp ? button["_treeExpandedFigure"] : button["_treeCollapsedFigure"];
          })
          .ofObject()),
      // assume initially not visible because there are no links coming out
      { visible: true }
		  // bind the button visibility to whether it's not a leaf node
		  /*,new go.Binding("visible", "isTreeLeaf",
						 function(leaf) { return !leaf; })
			  .ofObject()*/);

  // tree expand/collapse behavior
  button.click = function (e: any, button: any) {
    var node = button.part;
    if (node instanceof go.Adornment) node = node.adornedPart;
    if (!(node instanceof go.Node)) return;
    var diagram = node.diagram;
    if (diagram === null) return;
    var cmd = diagram.commandHandler;
    if (node.isTreeExpanded) {
      if (!cmd.canCollapseTree(node)) return;
    } else {
      if (!cmd.canExpandTree(node)) return;
    }
    e.handled = true;
    if (node.isTreeExpanded) {
      cmd.collapseTree(node);
    } else {
      cmd.expandTree(node);
    }
  };

  return button;
});


function treeSetting(marginObj: any) {

  return $$("BoTreeExpanderButtonChart", {
    width: 16,
    height: 16,
    "ButtonBorder.fill": null,
    "ButtonBorder.stroke": null,
    "_buttonStrokeNormal": null,
    "_buttonStrokeOver": null,
    "_buttonFillOver": null,
    margin: marginObj
  });
};



export class ChartTemplate {


  constructor() {

  }

  getNodeTemplate(selectNodeFn: any, addEmployeeFn: any, dragDropNode: any, clickOpenNode: any) {
    let nodeTemplate =
      $$(go.Node, "Spot",
        {
          selectionAdornmentTemplate:
            $$(go.Adornment, "Auto",
              $$(go.Shape,
                { fill: null, stroke: "#1e2ff1", strokeWidth: 2 },),
              $$(go.Placeholder)
            ), // end Adornment
          selectionObjectName: "BODY",
          doubleClick: function (e, obj) {
            selectNodeFn(obj, "doubleClick")
          },
          click: function (e, obj) {
            selectNodeFn(obj, "click")
          },
          contextClick: function (e, obj) {
            selectNodeFn(obj, "contextClick")
          },
          mouseEnter: (e: any, node: any) => node.findObject("BUTTON").opacity = 1,
          mouseLeave: (e: any, node: any) => node.findObject("BUTTON").opacity = 0,
          // handle dragging a Node onto a Node to (maybe) change the reporting relationship
          mouseDragEnter: (e: any, node: any, prev: any) => {
            const diagram: any = node.diagram;
            const selnode = diagram.selection.first();
            if (!mayWorkFor(selnode, node)) return;
            const shape = node.findObject("SHAPE");
            if (shape) {
              shape._prevFill = shape.fill;  // remember the original brush
              shape.fill = "#1e2ff1";
            }
          },
          mouseDragLeave: (e: any, node: any, next: any) => {
            const shape = node.findObject("SHAPE");
            if (shape && shape._prevFill) {
              shape.fill = shape._prevFill;  // restore the original brush
            }
          },
          mouseDrop: (e: any, node: any) => {
            const diagram = node.diagram;
            const selnode = diagram.selection.first();  // assume just one Node in selection
            if (mayWorkFor(selnode, node)) {
              // find any existing link into the selected node
              const link = selnode.findTreeParentLink();
              if (link !== null) {  // reconnect any existing link
                // console.log("node link not null",node.data)
                // console.log("link.fromNode link not null",link.fromNode.data)
                dragDropNode(node, link.fromNode)
                link.fromNode = node;
              } else {  // else create a new link
                console.log("node link null", node)
                diagram.toolManager.linkingTool.insertLink(node, node.port, selnode, selnode.port);
              }
            }
          }
        },
        // for sorting, have the Node.text be the data.name
        new go.Binding("text", "name"),
        // bind the Part.layerName to control the Node's layer depending on whether it isSelected
        new go.Binding("layerName", "isSelected", sel => sel ? "Foreground" : "").ofObject(),
        $$(go.Panel, "Auto",
          { name: "BODY" },
          // define the node's outer shape
          $$(go.Shape, "RoundedRectangle",
            { name: "SHAPE", fill: "white", portId: "" }),
          $$(go.Panel, "Vertical",


            $$(go.Panel, "Spot", { isClipping: true, alignment: go.Spot.Top, opacity: 1, margin: new go.Margin(15, 0, 0, 0), },
              $$(go.Shape, "Circle", { width: 60, strokeWidth: 0 }),
              $$(go.Picture,
                {

                  name: "Picture",
                  desiredSize: new go.Size(60, 60),
                  // margin: 1.5,
                  source: defualtProfileUrl,  // the default image
                },
                // new go.Binding("source", "pic", findHeadShot),
                new go.Binding("source", "profileUrl", findHeadShot),
              ),

            ),

            // define the panel where the text will appear
            $$(go.Panel, "Table",
              {
                minSize: new go.Size(150, NaN),
                maxSize: new go.Size(200, NaN),
                margin: new go.Margin(0, 0, 10, 0),
                defaultAlignment: go.Spot.Left
              },
              $$(go.RowColumnDefinition, { column: 2, width: 4 }),
              $$(go.TextBlock, textStyleName(),  // the name
                {
                  name: "NAMETB",
                  row: 0, column: 0, columnSpan: 5,
                  // editable: true, isMultiline: false,
                  minSize: new go.Size(50, 16),
                  margin: new go.Margin(20, 0, 0, 0),
                  alignment: go.Spot.Center,
                  textAlign: "center"
                },
                new go.Binding("text", "name").makeTwoWay()),

              $$(go.TextBlock, textStylePosition(),
                {
                  row: 1, column: 1, columnSpan: 4,
                  // editable: true, isMultiline: false,
                  minSize: new go.Size(50, 14),
                  margin: new go.Margin(0, 0, 0, 0),
                  alignment: go.Spot.Center,
                  textAlign: "center"

                },
                new go.Binding("text", "position").makeTwoWay()),

              $$(go.TextBlock, textStyle(),  // the comments
                {
                  row: 3, column: 0, columnSpan: 5,
                  wrap: go.TextBlock.WrapFit,
                  // editable: true,  // by default newlines are allowed
                  minSize: new go.Size(100, 14)
                },
                new go.Binding("text", "comments").makeTwoWay())
            ) // end Table Panel
          ) // end Horizontal Panel
        ), // end Auto Panel
        // $$("Button",
        //   $$(go.Shape, "PlusLine", { width: 10, height: 10 }),
        //   {
        //     name: "BUTTON", alignment: go.Spot.Right, opacity: 0,  // initially not visible
        //     click: (e, button) => this.addEmployee(button.part)
        //   },
        //   // button is visible either when node is selected or on mouse-over
        //   new go.Binding("opacity", "isSelected", s => s ? 1 : 0).ofObject()
        // ),

        $$("Button",
          // $$(go.Shape, "Circle", { width: 45, strokeWidth: 0 }),
          $$(go.Picture,
            {


              desiredSize: new go.Size(20, 20),
              source: window.location.origin + "/center-web/images/add.png",  // the default image

            },


          ),
          {
            name: "BUTTON", alignment: go.Spot.Right, opacity: 0,  // initially not visible
            click: (e, button) => addEmployeeFn(button.part)
          },
          new go.Binding("opacity", "isSelected", s => s ? 1 : 0).ofObject()

        ),


        new go.Binding("isTreeExpanded").makeTwoWay(),


        $$(go.Panel, "Spot", { alignment: go.Spot.Bottom, opacity: 1},
          new go.Binding("opacity", "childCount", (childCount: any) => {
            if (checkEmpty(childCount)) {
              return 0
            } else if (childCount > 0) {
              return 1
            } else {
              return 0;
            }
          }),
          $$(go.Shape, "RoundedRectangle", { width: 40, strokeWidth: 0, height: 20, fill: "black" }),
          $$(go.Panel, "Horizontal",

            $$(go.TextBlock, textStyle(),  // the comments
              {
                wrap: go.TextBlock.WrapFit,
                // editable: true,  // by default newlines are allowed
                minSize: new go.Size(10, 14)
                , stroke: "white"
                , margin: new go.Margin(1, 1, 1, 5)
              },
              new go.Binding("text", "childCount").makeTwoWay()),
            treeSetting(new go.Margin(1, 5, 1, 1))

          )
        ),




        $$(go.Panel, "Spot", { isClipping: true, alignment: go.Spot.Top, opacity: 0 },
          $$(go.Shape, "Circle", { width: 45, strokeWidth: 0 }),
          $$(go.Picture,
            {

              name: "Picture",
              desiredSize: new go.Size(45, 45),
              // margin: 1.5,
              source: defualtProfileUrl,  // the default image
            },
            // new go.Binding("source", "pic", findHeadShot),
            new go.Binding("source", "profileUrl", findHeadShot),
          ),

        )


        ,

        $$(go.Panel, "Spot", { isClipping: true, alignment: go.Spot.TopRight, opacity: 0 },
          $$(go.Shape, "Circle", { width: 45, strokeWidth: 0, margin: new go.Margin(30, 30, 0, 0), }),
          $$(go.Picture,
            {

              cursor: "pointer",
              name: "Picture",
              desiredSize: new go.Size(20, 20),
              margin: new go.Margin(30, 30, 0, 0),
              source: window.location.origin + "/center-web/images/paper-plane.png",  // the default image
            },
            // new go.Binding("source", "pic", findHeadShot),
            // new go.Binding("source", "profileUrl", findHeadShot),
          ),
          {
            // name: "BUTTON", alignment: go.Spot.Right, opacity: 0,  // initially not visible
            click: (e, button) => clickOpenNode(button.part)
          },
          new go.Binding("opacity", "isSelected", s => s ? 1 : 0).ofObject()
        )


      );  // end Node, a Spot Panel
    return nodeTemplate
  }


  getLinkTemplate() {
    let linkTemplate = $$(go.Link, go.Link.Orthogonal,
      { layerName: "Background", corner: 50 },
      $$(go.Shape, { strokeWidth: 2, stroke: "#000000" })
      , $$(go.Shape, { toArrow: "Circle" })
    );  // the link shape

    return linkTemplate;
  }
}